type Props = {
  vitals: any | null;
  hasLiveData: boolean;
  onConnectClick?: () => void;
};

export function BodyIndexCard({ vitals, hasLiveData, onConnectClick }: Props) {
  const v = vitals ?? {};

  const rows: Array<{ label: string; value: string; sub?: string; color?: string }> = [
    { label: "HRV",        value: v.hrv_avg            != null ? `${Math.round(v.hrv_avg)}` : "—", sub: v.hrv_avg != null ? "ms"                                                                : "no data",  color: hasLiveData ? "#2A9D8F" : undefined },
    { label: "Resting HR", value: v.resting_hr         != null ? `${Math.round(v.resting_hr)}` : "—", sub: v.resting_hr != null ? "bpm"                                                          : "no data",  color: hasLiveData ? "#A8DADC" : undefined },
    { label: "Sleep",      value: v.sleep_duration_hr  != null ? `${(v.sleep_duration_hr).toFixed(1)}` : "—", sub: v.sleep_duration_hr != null ? "hrs"                                            : "no data" },
    { label: "Recovery",   value: v.recovery_score     != null ? `${Math.round(v.recovery_score)}` : "—", sub: v.recovery_score != null ? "/100"                                                  : "no data", color: hasLiveData ? "#2A9D8F" : undefined },
    { label: "Stress",     value: v.stress_score       != null ? `${(v.stress_score / 10).toFixed(1)}` : "—", sub: v.stress_score != null ? "/10"                                                : "no data", color: hasLiveData ? "#F4A261" : undefined },
    { label: "Sessions",   value: `${v.sessions_this_quarter ?? 0}`,                                                                                          sub: "this quarter" },
  ];

  return (
    <div className="bg-d_card border border-d_border/20 rounded-[10px] p-4 transition-colors hover:border-d_celeste/10 h-full min-h-0 overflow-hidden flex flex-col">
      <div className="font-serif text-[17px] font-semibold mb-2.5 flex items-center justify-between tracking-[0.01em]">
        Body Index
        <span className="text-[10px] tracking-[1.8px] uppercase font-semibold" style={{ color: hasLiveData ? "#2A9D8F" : "rgb(var(--text3) / 0.7)" }}>
          {hasLiveData ? "Live" : "No device"}
        </span>
      </div>

      {!hasLiveData && (
        <button
          onClick={onConnectClick}
          className="mb-2 px-2.5 py-1.5 rounded-md border border-d_accent/30 text-d_accent text-[9px] font-semibold uppercase tracking-wider hover:bg-d_accent/[.08] transition w-full"
        >
          + Connect a wearable
        </button>
      )}

      <div className="flex-1 min-h-0 flex flex-col justify-between">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center justify-between py-2 border-b border-d_border/20 last:border-0">
            <div className="text-[12px] text-d_text2 font-semibold tracking-[0.01em]">{r.label}</div>
            <div className="flex items-baseline gap-1">
              <div
                className={`font-serif text-[26px] font-bold leading-none tabular-nums text-d_text ${!hasLiveData && r.label !== "Sessions" ? "opacity-40" : ""}`}
                style={r.color ? { color: r.color } : undefined}
              >
                {r.value}
              </div>
              {r.sub && (
                <div
                  className={`text-[11px] font-medium text-d_text2 ${!hasLiveData && r.label !== "Sessions" ? "opacity-40" : ""}`}
                  style={r.color ? { color: r.color } : undefined}
                >
                  {r.sub}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
